import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Menu
export interface Menu {
   path?: string;
   title?: string;
   type?: string;
   icon?: string;
   badgeType?: string;
   badgeValue?: string;
   active?: boolean;
   megaMenu?: boolean;
   megaMenuType?: string; // small, medium, large
   bookmark?: boolean;
   category?: string;
   children?: Menu[];
}

@Injectable({
   providedIn: 'root'
})
export class NavService {

   constructor() { }

   MENUITEMS: Menu[] = [
      {
         title: 'צור קשר', type: 'extTabLink', active: true, path: '/contact-us'
      },
      {
         title: 'אודות', type: 'extTabLink', active: true, path: '/about-us'
      },
      {
         title: 'בלוג', type: 'extTabLink', active: true, path: '/blog', category: 'all'
      },
      {
         title: 'קורסים וסדנאות', type: 'extTabLink', active: true, path: '/courses'
      },
      {
         title: 'גששות', type: 'sub', children: [
            { path: '/gallery', title: 'יונקים', type: 'link', category: 'mammals' },
            { path: '/gallery', title: 'זוחלים', type: 'link', category: 'reptiles' },
            { path: '/gallery', title: 'ציפורים', type: 'link', category: 'birds' },
            { path: '/gallery', title: 'פרוקי רגליים', type: 'link', category: 'arthropods' },
            { path: '/gallery', title: 'גללים', type: 'link', category: 'dumplings' },
            { path: '/gallery', title: 'דו-חיים', type: 'link', category: 'amphibians' },
            //  { path: '/gallery', title: 'סימנים נוספים', type: 'link', category: 'thought' },
         ]
      },
      {
         title: '', type: 'extTabLink', active: true, path: '/home', icon: 'home'
      },
   ];

   // Array
   items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

}
